import Cookie from 'modules/cookie'

const BANNER = ".global-promotion-banner",
      BANNER_LINK = `${BANNER} a`,
      BANNER_BUTTON = `${BANNER} .close-button`,
      BRANCH_BANNER = "#react-branchbanner-container",
      COOKIE_NAME = "global_promo_banner"

function setCookie () {Cookie.set(COOKIE_NAME, true, 1)}

function initCloseButton (banner) {
  const $button = document.querySelector(BANNER_BUTTON)
  $button.addEventListener('click', (event) => {
    event.preventDefault()
    banner.parentNode.removeChild(banner)
    document.body.style.marginTop = "0px"
    setCookie()
  })
}

function initBannerLink () {
  const $bannerLink = document.querySelector(BANNER_LINK);
  if ($bannerLink) {
    $bannerLink.addEventListener('click', (event) => {
      setCookie()
    })
  }
}

function isBranchActive () {
  const container = document.querySelector(BRANCH_BANNER)
  return (container && container.children.length > 0)
}

function init () {
  const $banner = (document.querySelector(BANNER) || null),
        branchActive = isBranchActive(),
        cookieActive = Cookie.isPresent([COOKIE_NAME])

  if ($banner && !branchActive && !cookieActive) {
    const bodyTopMargin = window.getComputedStyle($banner).getPropertyValue("height")
    initCloseButton($banner)
    initBannerLink()
    $banner.style.display = "block"
    document.body.style.marginTop = bodyTopMargin
  }
  // Banner is removed if the branch banner is active
  if ($banner && branchActive){ $banner.parentNode.removeChild($banner) }
}

export default { init }
